import React from "react";
import { images } from "../../data/content";
import { SectionCta } from "../SectionCta";
export function DoctorMessage() {
  return <section className="bg-white px-5 py-16 md:py-24" data-id="element-118" data-mp="37qjockf2vyt7">
      <div className="mx-auto grid max-w-5xl items-start gap-10 md:grid-cols-[2fr_3fr]" data-id="element-119" data-mp="3cola5d3w2c8d">
        <figure className="md:sticky md:top-8" data-id="element-120" data-mp="3hnxw7vmxrf9w">
          <img src={images.doctor} alt="Dr. Michael Carter" className="aspect-[4/5] w-full rounded-3xl object-cover object-top" data-id="element-121" data-mp="3hpsfl5ik6zbv" />
          <figcaption className="mt-3 text-center" data-id="element-122" data-mp="3qnucb8v9f5tc">
            <p className="font-serif text-xl font-black text-navy" data-id="element-123" data-mp="3qmjb9gt78c5x">Dr. Michael Carter</p>
            <p className="text-sm text-navy/60" data-id="element-124" data-mp="3vhp4l0oxkt41">Creator of The Abdominoplasty Master System™</p>
          </figcaption>
        </figure>

        <div data-id="element-125" data-mp="98xosof1d5e5">
          <p className="text-xs font-extrabold uppercase tracking-[0.18em] text-gold-dark" data-id="element-126" data-mp="9975fle6y076">A message from Dr. Michael Carter</p>
          <h2 className="mt-3 font-serif text-[30px] font-black leading-[1.1] text-navy md:text-4xl" data-id="element-127" data-mp="daiu9op8qheb">
            “I didn't create another <em className="italic text-gold-dark" data-id="element-128" data-mp="3w2k49qua0om7">abdominoplasty course.</em>”
          </h2>
          <div className="mt-6 space-y-4 text-[17px] leading-relaxed text-navy/80" data-id="element-129" data-mp="3r7wkg5a7widy">
            <p data-id="element-130" data-mp="3m6z5e1ki84go">I've spent years studying how experienced surgeons look at cases.</p>
            <p data-id="element-131" data-mp="3h8xl5dbcdz3m">
              And one thing became increasingly clear to me: knowing more information and knowing how to organize that
              information are not always the same thing.
            </p>
            <p data-id="element-132" data-mp="drfeh97b2y4s">
              You can watch another lecture. Read another paper. Attend another conference. Collect another folder of
              notes. But eventually, you need to sit down with a case and practice your thinking.
            </p>
            <p data-id="element-133" data-mp="11g87oxwjmrvp">I wanted to create something I could hand to a surgeon and say:</p>
            <blockquote className="rounded-2xl bg-navy p-5 font-serif text-xl font-bold italic leading-snug text-white" data-id="element-134" data-mp="wprrx7592u66">
              “Open this case. Take 15 minutes. Don't look for the answer yet. First, tell me what you see.”
            </blockquote>
            <p data-id="element-135" data-mp="2vvf0x0nl5c42">
              Then document your reasoning. Identify what you want to investigate. Prioritize the questions. Review the
              educational material. And finally, ask yourself: <strong className="text-navy" data-id="element-136" data-mp="2m5vfbn8hn45i">“What did I learn from this case?”</strong>
            </p>
            <p data-id="element-137" data-mp="2862prv8p6tz4">That's the philosophy behind The Abdominoplasty Master System™.</p>
            <p data-id="element-138" data-mp="2c98xz8fdev88">
              It's not intended to replace surgical training, mentorship, clinical experience, current evidence,
              institutional protocols or professional judgment. It's a case-based educational system designed to help
              you practice a more structured approach to reviewing abdominoplasty cases.
            </p>
            <p className="font-semibold text-navy" data-id="element-139" data-mp="3skwcfw991sdo">
              If you're serious about developing a more disciplined process for analyzing educational cases, I built
              this for you.
            </p>
            <p className="font-serif text-2xl font-black italic text-gold-dark" data-id="element-140" data-mp="1lwdtmis4nf9s">— Dr. Michael Carter</p>
          </div>
        </div>
      </div>
      <SectionCta label="I want access to the Abdominoplasty Master System™" data-id="element-141" data-mp="1vplap0w8cjpp" />
    </section>;
}